var AbstractViewModel = require("./AbstractViewModel")

function LocationSelectionViewModel(parent) {
    var self = this;

    self.forceLocationSelection = ko.observable(false);
    self.searchForLocation = ko.observable(null);
    self.selectedLocations = ko.observableArray([]);
  
    AbstractViewModel.apply(this, arguments);
  
    /**
     * Determines is the location selection is presented
     *
     * @method locationList
     * @returns {Boolean}
     */
    self.locationList = ko.computed(function() {
      var locations = parent.locations();
      var filter = self.searchForLocation();
      var availableLocations = locations;
  
      if (filter !== null) {
        availableLocations = locations.reduce(function(available, location) {
          if (location.description.toLowerCase().indexOf(filter.toLowerCase()) > -1) {
            available.push(location);
          }
  
          return available
        }, []);
      } 

      return self.sortedLocations(availableLocations);
  
    }, self, {
      deferEvaluation: true
    });
  
    /**
     * Determines is the location selection is displayed
     *
     * @method isVisible
     * @returns {Boolean}
     */
    self.isVisible = ko.computed(function() {
      return (
        parent.selectedLocationIds().length === 0 ||
        self.forceLocationSelection()
      );
    }, self, {
      deferEvaluation: true
    });
  
    /**
     * Determines if the location list is displayed
     *
     * @method locationSelectionShow
     * @returns {Boolean}
     */
    self.locationSelectionShow = ko.computed(function() {
      return parent.locations().length > 0 ||
        (self.searchForLocation() !== null && self.searchForLocation() !== '');
    }, self, {
      deferEvaluation: true
    });
  
  
    /**
     * Reset the model to its inital state
     *
     * @method reset
     * @returns none
     */
    self.reset = function() {
      self.forceLocationSelection(false);
      self.searchForLocation(null);
      self.selectedLocations([]);
    }

    /**
     * setter method to update the selected locations
     *
     * @method setLocationsIds
     * @param {Array} LocationIds
     * @returns none
     */
    self.setLocationsIds = function (locationIds) {
        self.selectedLocations(locationIds);
    }
  
    /**
     * Controls whether the button to select locations is enabled or not
     *
     * @method setSelectedLocationsBtnEnabled
     * @returns {Boolean}
     */
    self.setSelectedLocationsBtnEnabled = ko.computed(function() {
      return self.selectedLocations().length > 0;
    });

    /**
     * Sets locations for the parent view model
     *
     * @method setSelectedLocations
     * @returns none
     */
    self.setSelectedLocations = function () {
      parent.setSelectedLocationIds(self.selectedLocations())
    }
  
    /**
     * Returns of locations sorted by location description
     *
     * @method sortedLocations
     * @returns {Boolean}
     */
    self.sortedLocations = function(locations) {
      return locations.sort(function(a, b) {
        if (a.description.toLowerCase() === b.description.toLowerCase()) {
          return 0;
        }
        return (a.description.toLowerCase() < b.description.toLowerCase()) ? -1 : 1;
      });
    };
  
    return self;
  }
  
LocationSelectionViewModel.prototype = Object.create(Object.getPrototypeOf(AbstractViewModel.prototype));
LocationSelectionViewModel.prototype.constructor = LocationSelectionViewModel;

module.exports = LocationSelectionViewModel;
